import { ContentfulRenderer, Icon } from 'components';
import { Document } from '@contentful/rich-text-types';
import { ICta } from 'interfaces/IHxTraining';
import { Button } from 'components/UI/new';
import { openInNewTab } from 'utils/openInNewTab';
import { getUrlFromCta } from 'utils/getUrlFromCta';
import styles from './styles.module.scss';

interface IHxTrainingOTTSectionProps {
  title: string;
  description: Document;
  cta?: ICta;
}

const HxTrainingOTTSection = ({
  title,
  description,
  cta,
}: IHxTrainingOTTSectionProps) => (
  <div className={styles.ottSection}>
    <div className={styles.ottSectionTitleContainer}>
      <Icon iconType="newTab" width={16} height={16} />
      <h2 className={styles.ottSectionTitle}>{title}</h2>
    </div>
    <div className={styles.ottSectionDescription}>
      <ContentfulRenderer>{description}</ContentfulRenderer>
    </div>
    {cta && (
      <div className={styles.ottSectionCta}>
        <Button
          variant="primary"
          size="normal"
          icon="arrowRightThick"
          iconPosition="right"
          onClick={() => {
            openInNewTab(getUrlFromCta(cta));
          }}
        >
          {cta.title}
        </Button>
      </div>
    )}
  </div>
);

export default HxTrainingOTTSection;
